'use client';

import { Tooltip } from '@yanolja-rnd/nol-design-system';
import { IcInfo } from '@yanolja-rnd/nol-icons';
import { useState } from 'react';

interface SectionGroupHeaderProps {
  title?: string | null | undefined;
  tooltip?: string | null | undefined;
  id: number;
}

export const SectionGroupHeader = ({ title, tooltip, id }: SectionGroupHeaderProps) => {
  const tooltipId = `section-group-header-tooltip-${id}`;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative mb-[-1] mt-20 flex items-center justify-between px-16 pb-1 after:absolute after:-bottom-1 after:left-0 after:right-0 after:h-1 after:bg-static-white pc:mb-8 pc:mt-20 pc:px-0">
      <p className="text-text-neutral-sub typography-body-14-bold">{title}</p>
      {tooltip && (
        <>
          <span data-tooltip-id={tooltipId} className="cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
            <div className="inline-flex min-h-20 items-center justify-center gap-2 bg-static-white px-6 align-middle text-text-neutral-sub typography-caption-11-regular pc:min-h-20 pc:px-6">
              광고
              <IcInfo className="size-12" />
            </div>
          </span>
          {isOpen && (
            <Tooltip id={tooltipId} positionStrategy="absolute" place="bottom-end" className="z-10" isOpen={isOpen}>
              <div>{tooltip}</div>
            </Tooltip>
          )}
        </>
      )}
    </div>
  );
};
